import type { ReactNode } from 'react';
import { Button } from './button';
import { Modal } from './modal';
import { WorkingButton } from './working-button';

/**
 * The narrow "are you sure" modal: a head, the one line that says what will
 * happen, the confirm and the way out. Anything passed as children (an error
 * line, a standing answer) sits under the buttons.
 */
export function ConfirmModal({
  title,
  line,
  confirmLabel,
  workingLabel,
  working,
  danger = false,
  onConfirm,
  dismissLabel,
  onClose,
  children,
}: {
  title: string;
  line: ReactNode;
  confirmLabel: string;
  workingLabel: string;
  working: boolean;
  danger?: boolean;
  onConfirm: () => void;
  dismissLabel: string;
  onClose: () => void;
  children?: ReactNode;
}) {
  return (
    <Modal label={title} narrow onClose={onClose}>
      <div className="modal-head">{title}</div>
      <div className="modal-line">{line}</div>
      <div className="modal-actions">
        <WorkingButton
          label={confirmLabel}
          workingLabel={workingLabel}
          variant={danger ? 'danger' : undefined}
          working={working}
          onClick={onConfirm}
        />
        <Button variant="act" onClick={onClose}>
          {dismissLabel}
        </Button>
      </div>
      {children}
    </Modal>
  );
}
